module.exports = __webpack_public_path__ + "static/media/wings.5f96e48a.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners/images/wings.png
// module id = 1824
// module chunks = 146